import React from 'react'
import { Row, Image } from 'react-bootstrap'
import { MenuContainer } from '../../components/menuContainer/MenuContainer'
import { motion } from 'framer-motion'
import styled from 'styled-components'

const H3 = styled.h3`
  font-size: 34px;
  font-weight: bold;
  text-align: center;
  padding: 0px 17px 8px 17px;
  margin-bottom: 40px;
  display: inline-block;
  border-bottom: 4px solid #000;
`

const Description = styled.div`
  background-color: var(--bs-skyblue);
  width: 100%;
  height: auto;
  padding: 50px 80px;
  border-radius: 10px;

  @media (max-width: 1200px) {
    padding: 40px 50px;
  }

  @media (max-width: 992px) {
    padding: 25px 15px;
  }
`

const H4 = styled.h4`
  font-size: 30px;
  font-weight: bold;

  @media (max-width: 992px) {
    font-size: 25px;
  }
`

const P = styled.p`
  font-size: 16px;
  margin: 0px;
  color: #000000cc;

  @media (max-width: 1400px) {
    font-size: 14px;
  }

  @media (max-width: 1200px) {
    font-size: 13px;
  }

  @media (max-width: 992px) {
    font-size: 11px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 576px) {
    font-size: 14px;
  }

  @media (max-width: 490px) {
    font-size: 13px;
  }

  @media (max-width: 454px) {
    font-size: 10px;
  }
`
const DescriptionWrap = styled.div`
  padding-left: 44px;
  @media (max-width: 768px) {
    padding: 0px 40px;
  }
`

const ImageWrap = styled.div`
  padding-right: 44px;
  @media (max-width: 768px) {
    padding: 0px 40px;
    margin-bottom: 10px;
  }
`

const EquipmentInfoWrap = styled.div`
  margin-bottom: 189px;

  @media (max-width: 1200px) {
    margin-bottom: 150px;
  }

  @media (max-width: 992px) {
    margin-bottom: 120px;
  }

  @media (max-width: 768px) {
    margin-bottom: 100px;
  }
`

const EquipmentInfo = (props) => {
  return (
    <motion.div
      className="comment"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: false }}
      transition={{
        ease: 'easeInOut',
        duration: 1,
        y: { duration: 0.5 },
      }}
    >
      <EquipmentInfoWrap>
        <div className="text-center">
          <H3>{props.title}</H3>
        </div>
        <Row>
          <ImageWrap className="col-md-6 d-flex align-items-center">
            <picture>
              <source srcSet={`${props.img}.webp`} type="image/webp" />
              <Image src={`${props.img}.png`} alt={props.title} fluid />
            </picture>
          </ImageWrap>
          <DescriptionWrap className="col-md-6 d-flex align-items-center">
            <Description>
              <div className="d-flex justify-content-between mb-3">
                <H4>용량: {props.capacity}</H4>
                <H4>보유 대수: {props.possession}</H4>
              </div>
              <P dangerouslySetInnerHTML={{ __html: props.description }}></P>
            </Description>
          </DescriptionWrap>
        </Row>
      </EquipmentInfoWrap>
    </motion.div>
  )
}

export const Equipment = () => {
  return (
    <MenuContainer title="사업소개" menu="장비 현황" pointRadius="50%">
      <div className="comment-wrapper">
        <motion.div
          className="comment"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          "신뢰와 효율성을 보장하는 최첨단 물류 장비 솔루션"
        </motion.div>
        <motion.div
          className="detailed-comment"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          정직과 정도 경영을 바탕으로 고객의 요구를 충족하며,
          <br />
          혁신과 효율성으로 경쟁력을 확보하고&nbsp;
          <span className="d-block d-sm-none"></span>
          물류 산업을 선도하겠습니다.
        </motion.div>
      </div>
      <EquipmentInfo
        img={'/equipments/rich-stacker'}
        title={'리치스태커'}
        capacity={'70 t'}
        possession={'1'}
        description={`70톤급 리치스태커는 고중량 컨테이너 작업에 최적화된 중장비로,<br/>
          다양한 작업 환경에 따라 설계된 주요 특징들이 있습니다.<br/>
          리치스태커는 20~40피트 컨테이너를 들어 올릴 수 있으며,<br/>
          다층 컨테이너 적재 및 좁은 공간에서도 작업이 가능하도록 설계된<br/>
          텔레스코픽 스프레더를 탑재하고 있습니다.`}
      />
      <EquipmentInfo
        img={'/equipments/payloader'}
        title={'페이로우더'}
        capacity={'400 D'}
        possession={'2'}
        description={`페이로우더는 대용량 버킷으로<br/>
        자재를 빠르게 적재 · 운반할 수 있는 장비로,<br/>
        고하중 작업과 험난한 지형에서도 안정적으로 작동합니다.`}
      />
      <EquipmentInfo
        img={'/equipments/excavator'}
        title={'굴착기'}
        capacity={'10 t'}
        possession={'1'}
        description={`포크레인은 굴착과 토사 제거에 특화된 중장비로,<br/>
        유압 시스템과 회전 가능한 구조를 통해<br/>
        다양한 지형에서 효율적으로 작업할 수 있습니다.`}
      />
      <EquipmentInfo
        img={'/equipments/forklift'}
        title={'지게차'}
        capacity={'3,5,7 t'}
        possession={'3'}
        description={`지게차는 팔레트와 화물을 들어 올리거나 운반할 수 있는 중장비로,<br/>
        좁은 공간에서도 기동성이 뛰어나 물류작업에 최적되어 있습니다.`}
      />
    </MenuContainer>
  )
}
